import axiosClient from '@/api/axiosClient';
import { API_CREATE_BLOCK_MSISDN, API_GET_BLOCK_MSISDN } from '@/config/paths/API_PATH';

async function getBlockMsisdn({ isdn = null, limit, offset }) {
  const { data } = await axiosClient.get(API_GET_BLOCK_MSISDN, {
    params: {
      isdn,
      limit,
      offset,
    },
  });

  return data;
}

async function createBlockMsisdn({ isdn = null, id = [] }) {
  const { data } = await axiosClient.post(API_CREATE_BLOCK_MSISDN, {
    isdn,
    id,
  });

  return data;
}

export { getBlockMsisdn, createBlockMsisdn };
